import { render, staticRenderFns } from "./DeliverySettings.vue?vue&type=template&id=509a27b1"
import script from "./DeliverySettings.vue?vue&type=script&lang=ts"
export * from "./DeliverySettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports